import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import styles from "./statusList.module.scss";

interface StatusListProps {
  title?: string;
  data?: any[];
  labelKey?: string;
  valueKey?: string;
  colorKey?: string;
  showChevron?: boolean;
}

const StatusList: React.FC<StatusListProps> = ({
  title = "Status List",
  data = [],
  labelKey = "label",
  valueKey = "value",
  colorKey = "color",
  showChevron = true,
}) => {
  const defaultColors = [
    "#00d2aa",
    "#5b6b9e",
    "#ff9800",
    "#ff6b6b",
    "#999999",
    "#4a90a4",
  ];

  // Transform and normalize data
  const chartData = useMemo(() => {
    if (!data || data.length === 0) return [];

    return data.map((item, index) => ({
      label:
        item[labelKey] ||
        item.status ||
        item.label ||
        item.name ||
        `Item ${index + 1}`,
      value: Number(item[valueKey] || item.count || item.value || 0),
      color:
        item[colorKey] ||
        item.color ||
        defaultColors[index % defaultColors.length],
    }));
  }, [data, labelKey, valueKey, colorKey, defaultColors]);

  if (!chartData || chartData.length === 0) {
    return (
      <Box className={styles.container}>
        <Box className={styles.header}>
          <Typography variant="h6" className={styles.title}>
            {title}
          </Typography>
        </Box>
        <Box
          className={styles.listContainer}
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight={200}
        >
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h6" className={styles.title}>
          {title}
        </Typography>
      </Box>

      <Box className={styles.listContainer}>
        {chartData.map((item, index) => (
          <Box key={index} className={styles.listItem}>
            <Box className={styles.labelSection}>
              <Box
                className={styles.indicator}
                style={{ backgroundColor: item.color }}
              />
              <Typography className={styles.label}>{item.label}</Typography>
            </Box>
            <Box className={styles.valueSection}>
              <Typography className={styles.value}>{item.value}</Typography>
              {/* {showChevron && <ChevronRightIcon className={styles.chevronIcon} />} */}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StatusList;
